import React, { useState, useEffect, useContext } from "react";
import Header from "../components/application/header";
import Footer from "../components/application/footer";
import Sidebar from "../components/application/sidebar";
import HelpVideos from "../components/application/HelpVideos";
import PlanHeader from "../components/application/PlanHeader";
import ChoosePlans from "../components/application/ChoosePlans";

import { Route,useLocation } from "react-router-dom";
import { Switch } from "react-router";
import routes from "./Routes";
import _ from "lodash";
import moment from "moment";
import axios from "axios";
import Utils from "./../common/Utils";
import { UserContext } from "../common";
import { IAgree } from "../public";
import {Card,Alert} from "react-bootstrap";


function App() {
  const [showNoti, setShowNoti] = useState(false);
  const [notiData, setNotiData] = useState([]);
  const { userData, showPlan } = useContext(UserContext);
  const [sidebar, showSidebar] = useState(true);
  const loc = useLocation();

  // start auto logout
  const [inactive, setInactive] = useState(false);

  useEffect(() => {
    let timeout;

    const resetTimer = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => setInactive(true), 1000 * 60 * 60 * 3); //== 3 hours
    };

    const clearTimer = () => {
      clearTimeout(timeout);
      setInactive(false);
    };

    const events = ["mousemove", "mousedown", "keydown", "touchstart", "scroll", "wheel", "resize"];

    events.forEach((event) => {
      document.addEventListener(event, resetTimer, { passive: true });
    });

    resetTimer();

    return () => {
      events.forEach((event) => {
        document.removeEventListener(event, resetTimer);
      });
      clearTimer();
    };
  }, []);

  useEffect(() => {
    if (inactive) {
      // alert('You have been inactive for 1 minute.');
      window.location.href = `${process.env.PUBLIC_URL}/logout`;
    }
  }, [inactive]);

  // end auto logout
  const hideNoti = (e, nid) => {
    const remainingData = _.filter(notiData, (n) => n.id !== nid);
    // const notificationElement = e.currentTarget.closest('.notidata');
    // if (notificationElement) {
    //     notificationElement.remove();
    // }

    axios.post(Utils.apiUrl("tasks/hidenotification"), "nid=" + nid, Utils.apiHeaders()).then((res) => {
      console.log(res);
      if (res.data.success) {
        setNotiData(remainingData);
      }
    });
  };

  useEffect(function () {
    axios
      .get(Utils.apiUrl("tasks/getnotifications"), Utils.apiHeaders())
      .then((res) => {
        if(hasPlanAccess() && _.get(res,'data.forceLogout',false)){ //== already has access but plan expired then logout and reload
          if(Utils.getUserData()){
            Utils.setUserData(false);          
            window.location.reload();
          }
        }else if(!hasPlanAccess() && !_.get(res,'data.forceLogout',false)){ // == do not have access and plan renewed then also reload
          if(_.get(res.data,'plandata.plan',false)){
            //console.log("Test",res.data.plandata);
            Utils.addToUserData(res.data.plandata);
            window.location.reload();
          }          
        }
        else{
          if (_.get(res, "data.data", []).length > 0) {          
            setNotiData(res.data.data);
          }
          /*if(_.get(res.data,'plandata.plan',false)){
            //console.log("Test",res.data.plandata);
            Utils.addToUserData(res.data.plandata);
          }*/
        }
      })
      .catch((err) => {
        // do nothing
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (showNoti) {
      _.each(window.document.getElementsByClassName("notifyctrl"), (ele) => {
        if (ele.offsetLeft > 0) {
          window.document.getElementsByClassName("noticont")[0].style.width = window.document.body.offsetWidth - ele.offsetLeft + "px";
        }
      });
    }
  }, [showNoti]);

  useEffect(() => {
    _.each(window.document.getElementsByClassName("notifyctrl"), (ele) => {
      ele.setAttribute("src", process.env.PUBLIC_URL + "/images/" + (notiData.length > 0 ? "x" : "") + "notification.png");
    });
  }, [notiData]);

  const hasPlanAccess = () => {
    if(loc.pathname.includes('/logout')) return true;
    const planExpires = _.get(userData,'plan_expires',false);
    return !(userData.is_super_user && (planExpires===false || moment().isAfter(moment(planExpires))));
  };

  const showNoPlanBox = () => {
    return <><Card border="light" className="shadow dashboardStats h-100 mt-5 p-2">
      <Card.Body className="bg-light">
        <div className="alert alert-danger">
          <h1>No access!</h1>
          <p>
            Your subscription has expired, or the current plan is no longer active. 
            To continue enjoying our services, please activate your subscription.
          </p>
        </div>
      </Card.Body>
    </Card>
    <ChoosePlans />
    </>;
};


  return (
    <React.Fragment>
      <Header showNoti={showNoti} setShowNoti={setShowNoti} sidebar={sidebar} showSidebar={() => showSidebar(!sidebar)} />
      {showNoti && notiData.length === 0 && <div className="noticont nodata alert alert-warning">No Notifications found!</div>}
      {showNoti && notiData.length > 0 && (
        <div className="noticont">
          {notiData.map((nd) => (
            <div key={nd.id} className="notidata clickable" onClick={(e) => hideNoti(e, nd.id)}>
              <div dangerouslySetInnerHTML={{ __html: nd.notification }} />
            </div>
          ))}
        </div>
      )}
      <div className="wrapper" id="layoutSidenav">
        <div className={`sidebar-holder ${sidebar?'d-block':'d-none'}`}><Sidebar  /></div>
        <div className={`main ${sidebar?'':'pl-20'}`} id="layoutSidenav_content">
          {hasPlanAccess() && <>
          {userData.first === true && <IAgree />}
          {showPlan && <PlanHeader />}
          {userData.first === false && (
            <>
              <HelpVideos />
              <Switch>
                {routes.map((r) => (
                  <Route key={r.path} path={process.env.PUBLIC_URL + r.path} component={r.component} />
                ))}
              </Switch>
            </>
          )}
          </>}
          {hasPlanAccess()===false && showNoPlanBox()}
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
}

export default App;
